/**
 * AssetForm —— 新增固定資產（P2-6；`decisions/009`）
 * 由 `Assets.tsx` 抽出（頁面檔行數預算 ≤200）：成本／殘值／年期（月）／購入日。
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api, todayISO, type FixedAsset } from '../lib/api';

export default function AssetForm({ entityId, onCreated }: { entityId: string; onCreated: (a: FixedAsset) => void }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: '', category: '', acquiredDate: todayISO(), cost: '', salvage: '', lifeMonths: '36',
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true); setErr(null);
    try {
      const r = await api.createAsset({
        entityId, name: form.name, category: form.category || undefined, acquiredDate: form.acquiredDate,
        cost: form.cost, salvage: form.salvage || '0', lifeMonths: Number(form.lifeMonths),
      });
      onCreated(r.asset);
      setForm((f) => ({ ...f, name: '', category: '', cost: '', salvage: '' }));
    } catch (e) { setErr(e instanceof Error ? e.message : String(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <div className="fields">
        <label className="field">
          <span>{t('assets.name')} *</span>
          <input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            placeholder={t('assets.name_hint')} />
        </label>
        <label className="field">
          <span>{t('assets.category')}</span>
          <input value={form.category} onChange={(e) => setForm((f) => ({ ...f, category: e.target.value }))} />
        </label>
        <label className="field">
          <span>{t('assets.acquired_date')} *</span>
          <input type="date" value={form.acquiredDate} onChange={(e) => setForm((f) => ({ ...f, acquiredDate: e.target.value }))} />
        </label>
        <label className="field">
          <span>{t('assets.cost')} *</span>
          <input inputMode="decimal" value={form.cost} onChange={(e) => setForm((f) => ({ ...f, cost: e.target.value }))} placeholder="0.00" />
        </label>
        <label className="field">
          <span>{t('assets.salvage')}</span>
          <input inputMode="decimal" value={form.salvage} onChange={(e) => setForm((f) => ({ ...f, salvage: e.target.value }))} placeholder="0.00" />
        </label>
        <label className="field">
          <span>{t('assets.life_months')} *</span>
          <input inputMode="numeric" value={form.lifeMonths} onChange={(e) => setForm((f) => ({ ...f, lifeMonths: e.target.value }))} />
        </label>
      </div>
      {err && <p className="err">{err}</p>}
      <button className="cta" onClick={() => void submit()} disabled={busy || !form.name || !form.cost}>
        {t('assets.create')}
      </button>
      <p className="note">{t('assets.form_note')}</p>
    </>
  );
}
